export default "__VITE_ASSET__579d6ccd__"